/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SSETradeUpdate = {
    /**
     * Trade code or withdrawal ID
     */
    code?: string;
    /**
     * Steam trade ID (optional)
     */
    tradeId?: string;
    /**
     * 1=DEPOSIT, 2=WITHDRAW (optional)
     */
    type?: SSETradeUpdate.type;
    /**
     * Trade status code (optional)
     */
    status?: number;
    /**
     * Error message if trade failed (optional)
     */
    error?: string;
};
export namespace SSETradeUpdate {
    /**
     * 1=DEPOSIT, 2=WITHDRAW (optional)
     */
    export enum type {
        '_1' = 1,
        '_2' = 2,
    }
}

